import React from 'react';
import { motion } from 'framer-motion';

export const Terms = () => {
  return (
    <div className="min-h-screen bg-[#050505] pt-32 pb-24" data-testid="terms-page">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-[#D4AF37] text-sm uppercase tracking-[0.3em]">Legal</span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white mt-4 mb-6">
            Terms of <span className="italic text-[#D4AF37]">Use</span>
          </h1>
          <p className="text-white/50 text-sm mb-16">Effective date: January 1, 2026</p>

          <div className="space-y-10 text-white/75 leading-relaxed">
            <section>
              <p>
                Welcome to White Glove Event Concierge. These Terms of Use (&ldquo;Terms&rdquo;) govern your access to and use of our website, client portal, and services. By using this site, you agree to these Terms. If you do not agree, please discontinue use.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Our Services</h2>
              <p>
                White Glove Event Concierge provides strategic event consulting, advisory, and concierge services. We act as a liaison between clients and vendors, offering budget strategy, vendor recommendations, contract review, and communication guidance. We are not an event planner, licensed attorney, or financial advisor. Our recommendations and guidance are provided for informational and strategic purposes only.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Contract Review Disclaimer</h2>
              <p>
                Contract review services are intended to provide clarity, highlight key considerations, and support informed decision-making. We do not provide legal advice or representation. Clients are encouraged to consult a licensed attorney for any matter requiring legal interpretation.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Vendor Recommendations</h2>
              <p>
                Any vendor recommendations we provide are based on our professional experience and judgment. While we only recommend vendors we believe will serve our clients well, we are not responsible for the actions, performance, pricing, or service quality of any third-party vendor engaged as a result of our recommendations. All vendor agreements are between you and the vendor directly.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Payments & Engagement</h2>
              <p>
                All service packages require payment in accordance with the engagement letter or proposal provided at the time of booking. Strategy Sessions are paid in full prior to the session. Package engagements may require deposits and installment schedules. Details of refund, cancellation, and rescheduling policies will be specified in your individual engagement agreement.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Client Portal Use</h2>
              <p>
                If we create a client portal account on your behalf, you are responsible for safeguarding your login credentials and any activity occurring under your account. Notify us immediately at <a href="mailto:info@whitegloveeventconcierge.com" className="text-[#D4AF37] hover:underline">info@whitegloveeventconcierge.com</a> if you suspect unauthorized access.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Intellectual Property</h2>
              <p>
                All content on this website — including copy, imagery, branding, and methodology — is the property of White Glove Event Concierge and may not be reproduced, distributed, or used for commercial purposes without prior written consent.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Limitation of Liability</h2>
              <p>
                To the fullest extent permitted by law, White Glove Event Concierge is not liable for any indirect, incidental, or consequential damages arising out of your use of our site or services. Our total liability with respect to any service engagement shall not exceed the amount paid by the client for that engagement.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Governing Law</h2>
              <p>
                These Terms are governed by the laws of the State of Tennessee, without regard to conflict-of-laws principles. Any disputes arising out of these Terms or our services will be resolved in the state or federal courts located in Davidson County, Tennessee.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Changes to These Terms</h2>
              <p>
                We may update these Terms from time to time. Changes take effect when posted, and continued use of the site constitutes acceptance of the revised Terms.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl text-white mb-4">Contact</h2>
              <p>
                Questions about these Terms? Reach us at <a href="mailto:info@whitegloveeventconcierge.com" className="text-[#D4AF37] hover:underline">info@whitegloveeventconcierge.com</a>.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
